(function () {
	'use strict';

	angular
		.module('core.directives')
		.directive('companyPaymentMethods', CompanyPaymentMethods)

	/** @ngInject */
	function CompanyPaymentMethods($q, LoadingHelper, CompanyService, ParameterService, AuthenticationService, UtilHelper, PATHS) {
		function CompanyPaymentMethodsController() {
			const vm = this;
			const companyId = AuthenticationService.getUser().Company.Id;

			vm.getNumber = num => {
				return new Array(num);
			}

			vm.addParameter = () => {
				vm.amountOfParameters++;
			}

			vm.getPaymentMethods = () => {
				return ParameterService
					.getPaymentMethods()
					.then(success => {
						vm.paymentMethods = success;
					}, error => {
						UtilHelper.errorCallback(error);
						LoadingHelper.stopLoading('.paramter-container')
					})
			}

			vm.getCompanyPaymentMethods = () => {
				return CompanyService
					.getPaymentMethods(companyId)
					.then(success => {
						vm.companyPaymentMethods = success || [];
					}, error => {
						UtilHelper.errorCallback(error);
						LoadingHelper.stopLoading('.paramter-container')
					})
			}

			vm.checkPaymentMethod = paymentMethod => {
				let check = vm.companyPaymentMethods.find(el => el.Id == paymentMethod) ? true : false;

				return check;
			};

			vm.selectPaymentMethod = paymentMethod => {
				vm.paymentMethods.find(el => {
					if (el.Title == paymentMethod.Title)
						el.Checked = true
				})
			}

			vm.saveCompanyPaymentMethods = () => {
				LoadingHelper.startLoading('.plus-holder');

				const companyParametersPost = vm.paymentMethods.reduce((acc, cur) => {
					if (cur.Checked == true) {
						acc.push({
							Id: 0,
							Title: cur.Title
						})
					}

					return acc;
				}, []);

				ParameterService
					.postPaymentMethods(companyParametersPost, companyId)
					.then(successCallback, errorCallback);
			}

			init();

			function successCallback(success) {
				vm.companyPaymentMethods = success;

				UtilHelper.successCallback('update');
				LoadingHelper.stopLoading('.plus-holder');
			}

			function errorCallback(error) {
				LoadingHelper.stopLoading('.plus-holder');
				UtilHelper.errorCallback(error);
			}

			function init() {
				vm.companyPaymentMethods = [];
				vm.paymentMethods = [];

				LoadingHelper.startLoading('.paramter-container', true);

				$q
					.all([vm.getCompanyPaymentMethods(), vm.getPaymentMethods()])
					.then(
						success => {
							LoadingHelper.stopLoading('.paramter-container')
							vm.paymentMethods.forEach(el => el.Checked = vm.companyPaymentMethods.find(compEl => el.Id == compEl.Id) ? true : false);
						},
						error => {
							UtilHelper.errorCallback(error);
							LoadingHelper.stopLoading('.paramter-container')
						}
					)
			}
		}

		return {
			bindToController: true,
			controller: CompanyPaymentMethodsController,
			controllerAs: 'vm',
			restrict: 'AE',
			templateUrl: `${PATHS.PHYSICAL}/directives/company-payment-methods/company-payment-methods.html`
		}
	}
}());